import Immutable from 'immutable';

/**
 * Throw an error if there is no state key provided
 * @param {Object} action The action object
 * @private
 */
const _checkStateKey = (action) => {
    if (!action.stateKey) {
        throw new Error(`Action sent to validation reducer has no stateKey: ${JSON.stringify(action)}`);
    }
};

/**
 * Car Specific validation reducers
 * @type {Object}
 */
export const validationReducerCases = {
    SET_CLAIM_DETAILS_FORM_VALUE_WITH_RESET: (state, action) => {
        _checkStateKey(action);
        /**
         * When the form is updated on claim detail component we may want to reset touch in one atomic async function name(params) {
         * This is to reduce the rerender which does not help the state management
         */
        if (action.identifier === 'coverDetail.driver.claimsDetails') {
            return state.setIn(['touches', action.identifier], false);
        }
        return state;
    }
};
